import { TFN_DECLARATION } from '@/core/field-names';
import { TFNDeclarationFieldErrors } from '@/core/validation/field-errors';
import { isTFNValid } from '@/core/validation/common/tfn-declaration';

export async function validateTFNDeclaration(field) {
  const isAlphaNumeric = /^[0-9a-zA-Z]+$/;
  switch (field.name) {
    case TFN_DECLARATION.OPTION:
      if (!field.value) {
        return TFNDeclarationFieldErrors.EmptyOption;
      }
      break;
    case TFN_DECLARATION.TFN:
      if (field.appliedRules.visible && !field.value) {
        return TFNDeclarationFieldErrors.EmptyTFN;
      }
      if (
        field.value &&
        (!isAlphaNumeric.test(field.value) ||
          field.value.length !== 9 ||
          !isTFNValid(field.value))
      ) {
        return TFNDeclarationFieldErrors.InvalidTFN;
      }
      break;
    case TFN_DECLARATION.REASON:
      if (field.appliedRules.visible && !field.value) {
        return TFNDeclarationFieldErrors.EmptyReason;
      }
      break;
    case TFN_DECLARATION.TITLE:
      if (!field.value) {
        return TFNDeclarationFieldErrors.EmptyTitle;
      }
      break;
    case TFN_DECLARATION.NAME:
      if (!field.value) {
        return TFNDeclarationFieldErrors.EmptyName;
      }
      break;
    case TFN_DECLARATION.PAY_BASIS:
      if (!field.value) {
        return TFNDeclarationFieldErrors.EmptyPayBasis;
      }
      break;
    case TFN_DECLARATION.RESIDENT_STATUS:
      if (!field.value) {
        return TFNDeclarationFieldErrors.EmptyResidentStatus;
      }
      break;
    case TFN_DECLARATION.COUNTRY_OF_ORIGIN:
      if (field.appliedRules.visible && !field.value) {
        return TFNDeclarationFieldErrors.EmptyCountryOfOrigin;
      }
      break;
    case TFN_DECLARATION.TAX_FREE_THRESHOLD:
      if (!field.value) {
        return TFNDeclarationFieldErrors.EmptyTaxFreeTreshold;
      }
      break;
    case TFN_DECLARATION.HELP_LOAN_OR_STUDENT_DEBT:
      if (!field.value) {
        return TFNDeclarationFieldErrors.EmptyHelpLoan;
      }
      break;
    case TFN_DECLARATION.DECLARATION:
      if (!field.value) {
        return TFNDeclarationFieldErrors.EmptyDeclaration;
      }
      break;
  }
  return '';
}
